import styled from 'styled-components'
import Card from '../../../../components/card'

export const ListadoAvisoCard = styled(Card)`
  margin-bottom: 12px;
`
